export const ACCEPT_JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

const getInternAlApiRoot = () => (window.INTERNAL_API_ROOT ? window.INTERNAL_API_ROOT : null)

const getSubmittableV3ApiRoot = () =>
  window.SUBMITTABLE_V3_API_ROOT ? window.SUBMITTABLE_V3_API_ROOT : null

const getSubmittableBetaApiRoot = () =>
  window.SUBMITTABLE_BETA_API_ROOT ? window.SUBMITTABLE_BETA_API_ROOT : null

const getFundsDistributionApiRoot = () =>
  window.FUNDS_DISTRIBUTION_API_ROOT ? window.FUNDS_DISTRIBUTION_API_ROOT : null

const getFundsDistributionPaymentProcessingApiRoot = () =>
  window.FUNDS_DISTRIBUTION_PROCESSING_API_ROOT
    ? window.FUNDS_DISTRIBUTION_PROCESSING_API_ROOT
    : null

const getCsrApiRoot = () => window.CSR_API_ROOT ?? null

const getAblePortalApiRoot = () => window.ABLE_PORTAL_API_ROOT ?? null

const getAccountSystemApiRoot = () => window.ACCOUNT_SYSTEM_API_ROOT ?? null

const getOrganizationsApiRoot = () => window.ORGANIZATIONS_API_ROOT ?? null

const getAuthorizationManagementApiRoot = () => window.AUTHORIZATION_MANAGEMENT_API_ROOT ?? null

const getEnvironment = () => window.NODE_ENV ?? null

const getGMSApplicationId = () => window.GMS_APPLICATION_GUID ?? null

export const INTERNAL_API_ROOT = getInternAlApiRoot()
export const SUBMITTABLE_V3_API_ROOT = getSubmittableV3ApiRoot()
export const SUBMITTABLE_BETA_API_ROOT = getSubmittableBetaApiRoot()
export const FUNDS_DISTRIBUTION_API_ROOT = getFundsDistributionApiRoot()
export const FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT =
  getFundsDistributionPaymentProcessingApiRoot()
export const CSR_API_ROOT = getCsrApiRoot()
export const ABLE_PORTAL_API_ROOT = getAblePortalApiRoot()
export const ACCOUNT_SYSTEM_API_ROOT = getAccountSystemApiRoot()
export const ORGANIZATIONS_API_ROOT = getOrganizationsApiRoot()
export const AUTHORIZATION_MANAGEMENT_API_ROOT = getAuthorizationManagementApiRoot()
export const NODE_ENV = getEnvironment()
export const GMS_APPLICATION_GUID = getGMSApplicationId()
